import { ReactElement } from 'react';
import './Highlight.scss';

type HighlightProps = {
  text: string;
  terms: string[];
};

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Show some text with any occurrences of the terms highlighted
 */
export function Highlight({ text, terms }: HighlightProps): ReactElement {
  const validTerms = terms.filter(Boolean);
  if (!text || validTerms.length === 0) {
    return <>{text}</>;
  }

  // Longer terms are tried first, so "list" is preferred over "li"
  const pattern = new RegExp(
    `(${[...validTerms]
      .sort((a, b) => b.length - a.length)
      .map(escapeRegExp)
      .join('|')})`,
    'gi'
  );

  // Splitting on a pattern with a capture group puts the matches at odd indexes
  return (
    <>
      {text.split(pattern).map((part, i) =>
        i % 2 === 1 ? (
          <mark key={i} className="highlight">
            {part}
          </mark>
        ) : (
          part
        )
      )}
    </>
  );
}
